export enum ComparisonOperator {
  contains = "contains",
  equals = "equals",
  startsWith = "startsWith",
  endsWith = "endsWith",
  matchesRegex = "matchesRegex",
  populated = "populated",
}

export interface IFormComparisonOperator {
  name: string;
  value: ComparisonOperator;
  isNot: boolean;
  hasRightOperand: boolean;
}

export const FORM_COMPARISON_OPERATORS = {
  contains: {
    name: "Contains",
    value: ComparisonOperator.contains,
    isNot: false,
    hasRightOperand: true,
  },
  not_contains: {
    name: "Does Not Contain",
    value: ComparisonOperator.contains,
    isNot: true,
    hasRightOperand: true,
  },
  equals: {
    name: "Equals",
    value: ComparisonOperator.equals,
    isNot: false,
    hasRightOperand: true,
  },
  not_equals: {
    name: "Does Not Equal",
    value: ComparisonOperator.equals,
    isNot: true,
    hasRightOperand: true,
  },
  startsWith: {
    name: "Starts With",
    value: ComparisonOperator.startsWith,
    isNot: false,
    hasRightOperand: true,
  },
  not_startsWith: {
    name: "Does Not Starts With",
    value: ComparisonOperator.startsWith,
    isNot: true,
    hasRightOperand: true,
  },
  endsWith: {
    name: "Ends With",
    value: ComparisonOperator.endsWith,
    isNot: false,
    hasRightOperand: true,
  },
  not_endsWith: {
    name: "Does Not End With",
    value: ComparisonOperator.endsWith,
    isNot: true,
    hasRightOperand: true,
  },
  matchesRegex: {
    name: "Matches (Regex)",
    value: ComparisonOperator.matchesRegex,
    isNot: false,
    hasRightOperand: true,
  },
  not_matchesRegex: {
    name: "Does Not Match (Regex)",
    value: ComparisonOperator.matchesRegex,
    isNot: true,
    hasRightOperand: true,
  },
  // TODO: Allow for populated/not populated
  /*
  populated: {
    name: "Is Populated",
    value: ComparisonOperator.populated,
    isNot: false,
    hasRightOperand: false,
  },
  not_populated: {
    name: "Is Not Populated",
    value: ComparisonOperator.populated,
    isNot: true,
    hasRightOperand: false,
  },
  */
};

export const FORM_COMPARISON_LEFT_OPERAND_OPTION = "option";
